export default __webpack_public_path__ + "static/section_4_details_10-11becc2b15af8de3ca0db19ccae571a6.png";